import { Directive, ElementRef, Input } from '@angular/core';

// responsibility of the directive to control checkbox indeterminate state
@Directive({
  selector: '[atxIndeterminate]',
  standalone: false,
})
export class IndeterminateDirective {
  @Input()
  set atxIndeterminate(value: boolean) {
    this.elem.nativeElement.indeterminate = value;
  }

  constructor(private elem: ElementRef) {}
}
